var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 13.6667C13.1667 12.286 11.3012 11.1667 9 11.1667C6.69881 11.1667 4.83333 12.286 4.83333 13.6667M16.5 11.167C16.5 10.1418 15.4716 9.2608 14 8.87502M1.5 11.167C1.5 10.1418 2.52841 9.2608 4 8.87502M14 5.53011C14.5115 5.07234 14.8333 4.4071 14.8333 3.66669C14.8333 2.28597 13.714 1.16669 12.3333 1.16669C11.693 1.16669 11.109 1.4074 10.6667 1.80326M4 5.53011C3.48854 5.07234 3.16667 4.4071 3.16667 3.66669C3.16667 2.28597 4.28595 1.16669 5.66667 1.16669C6.30696 1.16669 6.89104 1.4074 7.33333 1.80326M9 8.66669C7.61929 8.66669 6.5 7.5474 6.5 6.16669C6.5 4.78597 7.61929 3.66669 9 3.66669C10.3807 3.66669 11.5 4.78597 11.5 6.16669C11.5 7.5474 10.3807 8.66669 9 8.66669Z",
    stroke: "#155a9e",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/vector3.a85cc6964c2027844a222703ff4ce319.svg";
export { ForwardRef as ReactComponent };